import React, { useContext } from "react";

export type GlobalContentTests = {
  score: number
  setScore: (c: number) => void
  testTimeGlobal: string
  setTestTimeGlobal: (c: any) => void
  arrayAnswers: Record<string, undefined>
  setArrayAnswers: (c: any) => void
  arrayCorrects: Record<string, unknown>
  setArrayCorrects: (c: any) => void
  arrayMiscellaneousCount: Record<string, any>
  setMiscellaneousCount: (c: any) => void
  globalMiscellaneous: Record<string, any>
  setGlobalMiscellaneous: (c: any) => void
}

export const GlobalStateContext = React.createContext<GlobalContentTests>({
  score: 0,
  setScore: () => {},
  testTimeGlobal: "",
  setTestTimeGlobal: () => {},
  arrayAnswers: {},
  setArrayAnswers: () => {},
  arrayCorrects: {},
  setArrayCorrects: () => {},
  arrayMiscellaneousCount: {},
  setMiscellaneousCount: () => {},
  globalMiscellaneous: {},
  setGlobalMiscellaneous: () => {},
});

export const useGlobalContext = () => useContext(GlobalStateContext);

export const getScore = (score: number): number => {
  return score;
};
export const getAnswers = (answers: any): number => {
  return answers;
};